import {
  WSButton,
  WSCard,
  WSElement,
  WSEmptyState,
  WSFlexBox,
  WSList,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { IWorkItem } from "@wingspanhq/payments/dist/interfaces";
import { IWorkDefinitionResponse } from "@wingspanhq/payments/dist/interfaces/api/workDefinition";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useQueryWorkLog } from "../../../../query/workLog/queries/useQueryWorkLog";
import { AcceptedValuesResources } from "../FormPartialAttributes/helpers";
import styles from "./index.module.scss";
import { Item } from "./Item";
import { useModalAddItem } from "./ModalAddItem";

type Props = {
  shimmer?: boolean;
  noEdit?: boolean;

  workLogId: string;
  payerId: string;
  payerPayeeEngagementId: string;

  workItems: IWorkItem[];
  workDefinitions: IWorkDefinitionResponse[];
  resources: AcceptedValuesResources;
};

export const CardWorkItems: React.FC<Props> = props => {
  const modalAddItem = useModalAddItem();
  const queryWorkLog = useQueryWorkLog(props.workLogId);

  return (
    <WSElement>
      <WSList gap="M">
        <WSElement>
          <WSSectionToolbar title="Work summary" />
          <WSText.ParagraphSm color="gray500">
            Work logging for this assignment is only available in U.S. Dollars
            (USD).
          </WSText.ParagraphSm>
        </WSElement>

        {props.workItems.length === 0 && !props.shimmer ? (
          <WSEmptyState
            type="documents"
            orientation="horizontal"
            size="S"
            title="No work added yet"
            description="Add work items to your work log to get started"
            hasBorder
            bgColor="white"
            actions={
              !props.noEdit
                ? {
                    buttons: [
                      {
                        kind: "Secondary",
                        label: "Add work",
                        onClick: () => {
                          modalAddItem.open({
                            workLogId: props.workLogId,
                            payerId: props.payerId,
                            workDefinitions: props.workDefinitions,
                            engagementId: props.payerPayeeEngagementId,
                            resources: props.resources
                          });
                        }
                      }
                    ]
                  }
                : undefined
            }
          />
        ) : (
          <>
            <WSCard
              className={props.shimmer ? undefined : styles.itemsCard}
              shimmer={props.shimmer}
            >
              {props.workItems.map(workItem => (
                <Item
                  key={workItem.workItemId}
                  noEdit={props.noEdit}
                  workItem={workItem}
                  workDefinitions={props.workDefinitions}
                  resources={props.resources}
                />
              ))}

              {!props.noEdit && (
                <WSElement>
                  <WSButton.Link
                    icon="plus-circle"
                    onClick={() => {
                      modalAddItem.open({
                        workLogId: props.workLogId,
                        payerId: props.payerId,
                        workDefinitions: props.workDefinitions,
                        engagementId: props.payerPayeeEngagementId,
                        resources: props.resources
                      });
                    }}
                  >
                    Add work
                  </WSButton.Link>
                </WSElement>
              )}
            </WSCard>
            <WSCard shimmer={props.shimmer}>
              <WSFlexBox
                wrap="nowrap"
                justify="space-between"
                alignItems="center"
              >
                <WSText color="gray500" weight="medium">
                  Total amount (USD)
                </WSText>
                <WSText.Heading5>
                  {formatMoney(queryWorkLog.data?.amount || 0, "USD")}
                </WSText.Heading5>
              </WSFlexBox>
            </WSCard>
          </>
        )}
      </WSList>
    </WSElement>
  );
};
